var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "multiple-widgets" },
    [
      _c("DefaultWidget", {
        ref: "button",
        attrs: {
          disabled: _vm.disabled,
          name: "保存视频元数据",
          icon: "mdi-download",
        },
        on: {
          click: function ($event) {
            return _vm.run("ffmetadata")
          },
        },
      }),
      _vm._v(" "),
      _c("DefaultWidget", {
        attrs: {
          disabled: _vm.disabled,
          name: "保存视频章节",
          icon: "mdi-download",
        },
        on: {
          click: function ($event) {
            return _vm.run("ogm")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }